import { useNavigate } from "react-router";
import { SpinnerLegacy } from "../../components";
import { useDashboardContext } from "../../components/dashboard/Dashboard.shared";
import { ErrorMessage } from "../../components/errorMessage/ErrorMessage";
import { NavigationBar } from "../../components/navigation/NavigationBar";
import { CUSTOMER } from "../../constants/routes";
import { useSupplierRelationship } from "../../hooks/api/v2/supplierRelationship/useSupplierRelationship";
import { MessageThread } from "../messages/MessageThread";

export const CustomerConversation = ({
  connectionId,
}: {
  connectionId: number;
}) => {
  const { isTwoPanel } = useDashboardContext();
  const navigate = useNavigate();

  const connectionQuery = useSupplierRelationship(connectionId);

  return (
    <>
      <NavigationBar
        title={connectionQuery.isLoading ? "Loading..." : "Conversation"}
        leftIcon={"CHEVRON_LEFT"}
        onClickLeftIcon={
          isTwoPanel
            ? undefined
            : () => navigate(CUSTOMER.href({ connectionId }))
        }
      />
      {connectionQuery.isError ? (
        <ErrorMessage>{connectionQuery.error.message}</ErrorMessage>
      ) : connectionQuery.isLoading ? (
        <SpinnerLegacy />
      ) : connectionQuery.isSuccess ? (
        <MessageThread relationshipId={connectionQuery.data.RelationshipId} />
      ) : null}
    </>
  );
};
